var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFaqCanvasNameIt = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4145_3495)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H44C50.6274 0 56 5.37258 56 12V44C56 50.6274 50.6274 56 44 56H12C5.37258 56 0 50.6274 0 44V12Z",
    fill: "#8D4DFF",
    fillOpacity: 0.12
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4145_3495",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 56
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H44C50.6274 0 56 5.37258 56 12V44C56 50.6274 50.6274 56 44 56H12C5.37258 56 0 50.6274 0 44V12Z",
    fill: "#BB1919"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4145_3495)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4145_3495)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1415 17.1682C15.6212 16.3217 16.3217 15.6212 17.1683 15.1415C17.7278 14.8245 18.3055 14.6632 18.8939 14.5538C19.4457 14.4512 20.1114 14.3773 20.874 14.2925L25.2108 13.8106C26.0457 13.7169 26.7813 13.6344 27.5058 13.7499C28.1417 13.8513 28.7541 14.0662 29.314 14.3842C29.9519 14.7465 30.4748 15.2705 31.0682 15.8652L40.4397 25.2368C41.1075 25.9047 41.6837 26.4808 42.1195 26.9941C42.5794 27.5359 42.9872 28.1244 43.2224 28.848C43.5731 29.9276 43.5731 31.0904 43.2224 32.17C42.9872 32.8936 42.5794 33.4821 42.1195 34.0239C41.6837 34.5372 41.1076 35.1133 40.4397 35.7811L35.7812 40.4397C35.1133 41.1075 34.5372 41.6837 34.0239 42.1195C33.4821 42.5794 32.8936 42.9872 32.17 43.2223C31.0905 43.5731 29.9276 43.5731 28.8481 43.2223C28.1245 42.9872 27.5359 42.5794 26.9941 42.1195C26.4808 41.6837 25.9047 41.1075 25.2369 40.4397L15.8653 31.0682C15.2706 30.4748 14.7466 29.9519 14.3842 29.314C14.0662 28.7541 13.8513 28.1417 13.7499 27.5058C13.6344 26.7813 13.7169 26.0457 13.8106 25.2108L14.2925 20.8745C14.3772 20.1117 14.4512 19.4458 14.5538 18.8939C14.6633 18.3055 14.8245 17.7277 15.1415 17.1682ZM24.808 24.8079C25.6826 23.9333 25.6826 22.5153 24.808 21.6407C23.9334 20.7661 22.5154 20.7661 21.6407 21.6407C20.7661 22.5153 20.7661 23.9333 21.6407 24.8079C22.5154 25.6825 23.9334 25.6825 24.808 24.8079Z",
    fill: "#A788FF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.1989 17.0142C42.8577 15.673 40.6833 15.673 39.3421 17.0142L38.3281 18.0282L43.185 22.885L44.1989 21.8711C45.5401 20.5299 45.5401 18.3554 44.1989 17.0142Z",
    fill: "#50307E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7708 24.2992L36.9139 19.4424L30.6312 25.7251C29.801 26.5553 29.2625 27.6323 29.0964 28.7946L28.7313 31.3505C28.6868 31.6621 28.7916 31.9764 29.0142 32.199C29.2367 32.4216 29.5511 32.5263 29.8627 32.4818L32.4186 32.1167C33.5808 31.9507 34.6578 31.4122 35.488 30.582L41.7708 24.2992Z",
    fill: "#50307E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4145_3495",
    x: -8.30661,
    y: 1.69337,
    width: 73.7921,
    height: 73.792,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_4145_3495"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.027451 0 0 0 0 0.101961 0 0 0 0 0.141176 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4145_3495"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4145_3495",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4145_3495"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFaqCanvasNameIt);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/faq_canvas_name_it.f47baf8eeef5f8b26b3d733bfbbe0544.svg";